import { Layout, Layouts } from 'react-grid-layout';

export function createConstantLayout(layout: Layout[]): Layouts {
  return {
    // Per il mobile, gestiamo un unica colonna.
    sm: layout.map(m => ({ ...m, x: 0, w: 1, minW: 1 })),
    lg: layout
  };
}
